export default __webpack_public_path__ + "static/media/nifc-logo-small.f5ef1650.png";